import IconButton from '@mui/material/IconButton';
import PaymentIcon from '@mui/icons-material/Payment';
import { useSelector, useStore } from 'react-redux';
import { toastr } from 'react-redux-toastr';

interface AddToPaymentCartProps {
  parcels: Array<{
    id: number;
    addToBalance: boolean;
    payment?: {
      id?: number;
    };
    company: {
      id: number;
    };
  }>;
  company?: {
    value: number;
    label: string;
  };
}

export default function AddToPaymentCartBulk({ company, parcels }: AddToPaymentCartProps) {
  const store = useStore();
  const paymentCompany = useSelector((state: any) => state?.payment?.companyID);

  function Action() {
    if (!company?.value) {
      toastr.warning('No Company', 'Please Select Company First');
      return;
    }

    if (paymentCompany !== null && paymentCompany !== company?.value) {
      toastr.warning('Not Same Company', 'Please add payment from same company');
      return;
    }

    parcels.forEach((parcel) => {
      if (parcel.company.id !== company?.value) {
        toastr.warning('Not Same Company', 'Parcel ID ' + parcel.id + ' is not from same company');
        return;
      }

      if (!parcel.addToBalance) {
        toastr.warning('Not Add To Balance', 'Parcel ID ' + parcel.id + ' is not add to balance');
        return;
      }

      if (parcel.payment?.id) {
        toastr.warning('Already Paid', 'Parcel ID ' + parcel.id + ' is already paid');
        return;
      }

      store.dispatch({ type: 'ADD_PARCEL_ID', payload: parcel.id });
    });

    store.dispatch({ type: 'UPDATE_COMPANY_ID', payload: company?.value });
  }

  function addToCartButton() {
    return (
      <IconButton style={{ color: '#2e7d32' }} onClick={Action}>
        <PaymentIcon />
      </IconButton>
    );
  }

  return addToCartButton();
}
